import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import selected from './slices/selected';

const clientReducer = combineReducers({
  selected: persistReducer(
    {
      key: 'selected',
      storage,
      blacklist: ['urlLoad'],
    }, selected,
  ),
});

export default clientReducer;
